var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "v-spinner",
    },
    [
      _c(
        "div",
        { staticClass: "v-bounce v-bounce1", style: _vm.spinnerBasicStyle },
        [
          _c("div", {
            staticClass: "v-bounce v-bounce2",
            style: _vm.spinnerStyle,
          }),
          _c("div", {
            staticClass: "v-bounce v-bounce3",
            style: _vm.spinnerStyle,
          }),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /Users/kinfirm/Sites/mvgroup/wp-content/themes/mvgroup/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/Users/kinfirm/Sites/mvgroup/wp-content/themes/mvgroup/node_modules/vue-loader/lib?{}!/Users/kinfirm/Sites/mvgroup/wp-content/themes/mvgroup/node_modules/vue-spinner/src/BounceLoader.vue?vue&type=template&id=25786eca&
// module id = 622
// module chunks = 0